export const BILLING_NUMBER = {
  MIN_CHAR: 1,
  MAX_CHAR: 42,
};
